<!--
 * @Descripttion:
 * @version:
 * @Author: yenible
 * @Date: 2024-06-19 22:58:15
-->

<template>
    <div class="bg_container">
        <template v-if="curPath == '/messagesend'">
            <div class="default_bg message_send">
                <img src="../../image/messageSend/banner.png" alt="" />
                <img
                        class="inner_content inner_img1"
                        src="../../image/messageSend/banner_logo.png"
                        alt=""
                />
                <div class="inner_content inner_title">短信发送</div>
                <div class="inner_content inner_title2">
                    <!--          <div class="button visit" @click="handleClick">立即接入使用</div>-->
                </div>
            </div>
        </template>
        <template v-else-if="curPath == '/numverify'">
            <div class="default_bg num_verify">
                <img  src="../../image/numVerify/banner.png" alt="" />
                <img
                        class="inner_content inner_img1"
                        src="../../image/numVerify/banner_logo.png"
                        alt=""
                />
                <div class="inner_content inner_title_wrap1 ">企业电话认证一级服务商</div>
                <div class="inner_content inner_title_wrap2">
                    <div class="inner_content inner_title">号码认证</div>
                    <img
                            class="inner_arrow"
                            src="../../image/numVerify/banner_arrow.png"
                            alt=""
                    />
                </div>
            </div>
        </template>
        <template v-else-if="curPath == '/smsverify'">
            <div class="default_bg sms_verify">
                <img src="../../image/smsVerify/banner.png" alt="" />
                <img
                        class="inner_content inner_img1"
                        src="../../image/smsVerify/inner_banner1.png"
                        alt=""
                />
                <div class="inner_content inner_title">短信认证</div>
            </div>
        </template>
        <template v-else-if="curPath == '/flashLetter'">
            <div class="default_bg flash_letter">
                <img src="../../image/flashLetter/banner.png" alt="" />
                <img
                        class="inner_content inner_img1"
                        src="../../image/flashLetter/inner_banner1.png"
                        alt=""
                />
                <div class="inner_content inner_title">来电名片/挂机短信</div>
            </div>
        </template>
        <template v-else-if="curPath == '/aboutus'">
            <div class="default_bg aboutus">
                <img src="../../image/aboutus/banner.png" alt="" />
                <div class="inner_content inner_title">关于我们</div>
            </div>
        </template>
        <template v-else-if="curPath == '/contactus'">
            <div class="default_bg aboutus">
                <img src="../../image/aboutus/banner.png" alt="" />
                <div class="inner_content inner_title">联系我们</div>
            </div>
        </template>
        <template v-else>
            <el-carousel
                    class="bg"
                    height="auto"
                    autoplay
                    :interval="2000"
                    arrow="always"
                    indicator-position="none"
            >
                <el-carousel-item
                        v-for="(item, index) in imgArr"
                        :key="index"
                        class="carousal_item"
                >
                    <el-image class="image" :src="item" fit="cover" />
                </el-carousel-item>
            </el-carousel>
            <Panel />
        </template>
    </div>
</template>

<script setup>
    import { ref } from "vue";
    import BG1 from "../../image/home/home-bg/BG1.png";
    import BG2 from "../../image/home/home-bg/BG2.png";
    import BG3 from "../../image/home/home-bg/BG3.png";
    import Panel from "./HomeTitlePanel.vue";
    import { RouterLink, useRoute } from "vue-router";
    import { onMounted, watch } from "vue";

    const route = useRoute();
    const imgArr = ref([BG1, BG2, BG3]);
    const curPath = ref("");
    onMounted(() => {
        curPath.value = route.path;
        console.log(route);
        console.log(route.path);
    });

    watch(
        () => route.path,
        (newPath, oldPath) => {
            console.log(newPath);
            curPath.value = newPath;
        },
        { immediate: true }
    );
</script>

<style lang="scss" scoped>
    .bg_container {
        width: 100%;
        min-height: 540px;
        position: relative;

        .bg {
            width: 100%;

            .carousal_item {
                width: 100%;
                min-height: 600px;
            }

            .image {
                width: 100%;
            }
        }

        .default_bg {
            position: relative;
            font-size: 0;

            img {
                width: 100vw;
                height: auto;
            }

            .inner_content {
                position: absolute;
            }

            .inner_title {
                font-size: 42px;
                line-height: 67px;
                color: #fff;
            }

            .inner_title2 {
                font-size: 48px;
                line-height: 67px;
                color: #fff;
            }

            .title {
                position: absolute;
                font-size: 40px;
                color: #ffffff;
                font-weight: bolder;
                left: 50%;
                top: 45%;
                transform: translate(-50%);
            }

            .contact_title {
                font-family: FZLanTingHei-H-GBK;
                font-size: 60.83px;
                font-weight: 600;
                line-height: 76.04px;
                text-align: center;
            }
        }
        .num_verify {
            position: relative;
            .inner_img1 {
                position: absolute;
                width: 700.73px;
                height: 391px;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
            }
            .inner_title_wrap1 {
                top: 15%;
                left: 20%;
                transform: translateX(-50%);
                font-size: 24px;
                color: #dcdcdc;
            }
            .inner_title_wrap2 {
                position: absolute;
                width: 192px;
                height: 120px;
                top: 50%;
                left: 50%;
                transform: translateX(-50%);
            }
            .inner_arrow {
                position: absolute;
                width: 187px;
                height: 48.5px;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .message_send {
            .inner_img1 {
                width: 430px;
                left: 50%;
                transform: translateX(-20%);
                bottom: 0;
            }

            .inner_title {
                left: 12%;
                bottom: 45%;
            }

            .inner_title2 {
                left: 155px;
                bottom: 176px;
            }

            .button {
                min-width: 160px;
                border-radius: 40px;
                text-align: center;
                line-height: 40px;
                font-weight: 600;
            }

            .visit {
                background: #5236ff;
                color: #ffffff;
                font-size: 16px;
            }
        }
        .sms_verify {
            .inner_img1 {
                width: 355px;
                left: 48%;
                bottom: 0;
            }

            .inner_title {
                left: 12%;
                bottom: 45%;
            }
        }

        .flash_letter {
            .inner_img1 {
                width: 230px;
                left: 48%;
                bottom: 0;
            }

            .inner_title {
                left: 12%;
                bottom: 45%;
            }
        }

        .aboutus {
            .inner_title {
                font-size: 60px;
                line-height: 76px;
                font-weight: 600;
                left: 50%;
                top: 232px;
                transform: translateX(-50%);
            }
        }
        :deep(.el-carousel__container) {
            height: 43.5vw !important;
        }
    }
</style>
